import colors from './colors';
import dimensions from './dimensions';
import typography from './typography';

export { colors, dimensions, typography };
